export const brands = [
  {
    id: 'bluestar',
    name: 'BlueStar',
    services: ['ac-repair', 'water-purifier-repair', 'refrigerator-repair']
  },
  {
    id: 'bosch',
    name: 'Bosch',
    services: ['washing-machine-repair', 'refrigerator-repair', 'microwave-repair']
  },
  {
    id: 'bpl',
    name: 'BPL',
    services: ['tv-repair', 'refrigerator-repair']
  },
  {
    id: 'carrier',
    name: 'Carrier',
    services: ['ac-repair']
  },
  {
    id: 'croma',
    name: 'Croma',
    services: ['tv-repair', 'refrigerator-repair', 'washing-machine-repair']
  },
  {
    id: 'daikin',
    name: 'Daikin',
    services: ['ac-repair']
  },
  {
    id: 'electrolux',
    name: 'Electrolux',
    services: ['washing-machine-repair', 'refrigerator-repair']
  },
  {
    id: 'ge',
    name: 'GE',
    services: ['refrigerator-repair', 'washing-machine-repair', 'microwave-repair']
  },
  {
    id: 'gem',
    name: 'GEM',
    services: ['tv-repair', 'refrigerator-repair']
  },
  {
    id: 'godrej',
    name: 'Godrej',
    services: ['refrigerator-repair', 'washing-machine-repair', 'ac-repair']
  },
  {
    id: 'haier',
    name: 'Haier',
    services: ['refrigerator-repair', 'washing-machine-repair', 'ac-repair']
  },
  {
    id: 'hitachi',
    name: 'Hitachi',
    services: ['ac-repair', 'refrigerator-repair', 'washing-machine-repair']
  },
  {
    id: 'hyundai',
    name: 'Hyundai',
    services: ['tv-repair', 'refrigerator-repair', 'washing-machine-repair']
  },
  {
    id: 'ifb',
    name: 'IFB',
    services: ['washing-machine-repair', 'microwave-repair']
  },
  {
    id: 'kelvinator',
    name: 'Kelvinator',
    services: ['refrigerator-repair']
  },
  {
    id: 'kenstar',
    name: 'KenStar',
    services: ['microwave-repair']
  },
  {
    id: 'koryo',
    name: 'Koryo',
    services: ['tv-repair', 'ac-repair']
  },
  {
    id: 'lg',
    name: 'LG',
    services: ['tv-repair', 'refrigerator-repair', 'washing-machine-repair', 'ac-repair', 'microwave-repair']
  },
  {
    id: 'lloyd',
    name: 'Lloyd',
    services: ['ac-repair', 'tv-repair']
  },
  {
    id: 'midea',
    name: 'Midea',
    services: ['ac-repair', 'refrigerator-repair']
  },
  {
    id: 'mitsubishi',
    name: 'Mitsubishi',
    services: ['ac-repair']
  },
  {
    id: 'napoleon',
    name: 'Napoleon',
    services: ['microwave-repair']
  },
  {
    id: 'ogeneral',
    name: 'OGeneral',
    services: ['ac-repair']
  },
  {
    id: 'onida',
    name: 'Onida',
    services: ['tv-repair', 'ac-repair']
  },
  {
    id: 'panasonic',
    name: 'Panasonic',
    services: ['tv-repair', 'ac-repair', 'refrigerator-repair', 'microwave-repair']
  },
  {
    id: 'philips',
    name: 'Philips',
    services: ['tv-repair', 'microwave-repair']
  },
  {
    id: 'samsung',
    name: 'Samsung',
    services: ['tv-repair', 'refrigerator-repair', 'washing-machine-repair', 'ac-repair', 'microwave-repair']
  },
  {
    id: 'sansui',
    name: 'Sansui',
    services: ['tv-repair']
  },
  {
    id: 'sanyo',
    name: 'Sanyo',
    services: ['tv-repair', 'refrigerator-repair']
  },
  {
    id: 'sharp',
    name: 'Sharp',
    services: ['tv-repair', 'microwave-repair', 'refrigerator-repair']
  },
  {
    id: 'siemens',
    name: 'Siemens',
    services: ['washing-machine-repair', 'refrigerator-repair']
  },
  {
    id: 'tcl',
    name: 'TCL',
    services: ['tv-repair', 'ac-repair']
  },
  {
    id: 'toshiba',
    name: 'Toshiba',
    services: ['tv-repair', 'refrigerator-repair', 'washing-machine-repair']
  },
  {
    id: 'vestar',
    name: 'Vestar',
    services: ['ac-repair']
  },
  {
    id: 'videocon',
    name: 'Videocon',
    services: ['tv-repair', 'washing-machine-repair', 'refrigerator-repair', 'ac-repair']
  },
  {
    id: 'voltas',
    name: 'Voltas',
    services: ['ac-repair']
  },
  {
    id: 'whirlpool',
    name: 'Whirlpool',
    services: ['refrigerator-repair', 'washing-machine-repair', 'microwave-repair', 'ac-repair']
  },
  {
    id: 'white-westinghouse',
    name: 'White Westinghouse',
    services: ['refrigerator-repair', 'washing-machine-repair']
  }
] as const;

export type Brand = typeof brands[number];
export type BrandId = Brand['id'];
export type ServiceId = Brand['services'][number];

// Helper functions
export function getBrandsByService(serviceId: ServiceId): Brand[] {
  return brands.filter(brand => brand.services.includes(serviceId));
}

export function getBrand(brandId: BrandId): Brand | undefined {
  return brands.find(brand => brand.id === brandId);
}

export function getServicesForBrand(brandId: BrandId): ServiceId[] {
  const brand = getBrand(brandId);
  return brand ? brand.services : [];
}